import { render, staticRenderFns } from "./NewLeadPipelineStageControl.vue?vue&type=template&id=20eb136a&scoped=true"
import script from "./NewLeadPipelineStageControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewLeadPipelineStageControl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb136a",
  null
  
)

export default component.exports